import React from "react";

/**
 * step 1007: React.Fragment, also known as the shorthand <> </>, is a feature in React that allows you to group multiple elements together without adding an extra wrapping element to the DOM. It is useful when you want to return multiple elements from a component, but you don't want to add an additional HTML element in the rendered output.
 * @param props
 * @returns {React.JSX.Element}
 * @constructor
 */
const Auxs = (props) => <React.Fragment>{props.children}</React.Fragment>;
export default Auxs;
